import { EmailOpenIcon } from './EmailOpenIcon';

/**
 * author: Austin Andrews
 * id 1E550A45-9D97-4918-9DEC-F536EC5C7A1C
 * name email-open
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/email-open.svg
 * tags
 */
export const DraftsIcon = EmailOpenIcon;
export default DraftsIcon